import React, { useState } from "react";
import { Content, ContentHeader, Header } from "@backstage/core-components";
import { Button } from "@material-ui/core";
import { useIsAdmin } from "../../hooks";
import { LockOutPage } from "../LockOutPage";
import { useApi, alertApiRef } from "@backstage/core-plugin-api";
import { opsReviewApiRef } from "@internal/plugin-ops-review";

export interface Props {}

export const AdminPanelPage: React.FC<Props> = (): JSX.Element => {
  const isAdmin = useIsAdmin();
  const opsreview = useApi(opsReviewApiRef);
  const alertApi = useApi(alertApiRef);
  const [isProcessingHistory, setIsProcessingHistory] = useState(false);

  if (!isAdmin) {
    return <LockOutPage />;
  }

  return (
    <div data-testid="admin-panel">
      <Header title="Admin Panel" />
      <Content>
        <div>
          <ContentHeader title="OpsReview" />
          <Content>
            <Button
              variant="outlined"
              onClick={async () => await opsreview.fetchOwnership()}
            >
              Import ownership data for OpsReview
            </Button>
            <Button
              variant="outlined"
              disabled={isProcessingHistory}
              onClick={async () => {
                setIsProcessingHistory(true);
                try {
                  await opsreview.processHistory();
                  alertApi.post({
                    message: "OpsReview history processed successfully!",
                    severity: "success",
                  });
                } catch (error) {
                  alertApi.post({
                    message: `Error processing history: ${error}`,
                    severity: "error",
                  });
                } finally {
                  setIsProcessingHistory(false);
                }
              }}
            >
              {isProcessingHistory
                ? "Processing..."
                : "Process OpsReview History"}
            </Button>
          </Content>
        </div>
      </Content>
    </div>
  );
};
